import graphql__6cbaffe096bcf7897e2b from "./__generated__/HeaderAuthenticatedUser_authenticationConfig.graphql.js";
import graphql__eacef6b6aa6b4a2dc72a from "./__generated__/HeaderAuthenticatedUser_viewer.graphql.js";import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";
import classNames from "classnames";

import { useFormatMessage } from "../Intl/Context";
import { withAuthenticationManager } from "../GeneralServices/AuthenticationService";

import UserAvatar from "../Users/UserAvatar";
import Button from "../Buttons/Button";
import ButtonLink from "../Buttons/ButtonLink";
import { useRoutesContext } from "../Routes/RoutesContext";
import { useResponsiveFlag } from "../Utils/ResponsiveQueries";
import initials from "../Utils/initials";

const HeaderAuthenticatedUser = props => {
  const authenticationConfig = useFragment(
    HeaderAuthenticatedUser_authenticationConfig,
    props.authenticationConfig
  );
  const viewer = useFragment(HeaderAuthenticatedUser_viewer, props.viewer);

  const { withinComplexMenu } = props;
  const { isDesktop } = useResponsiveFlag();
  const desktopLegacyDisplay = !withinComplexMenu && isDesktop;

  const { pathFor } = useRoutesContext();

  const userNameInitials = initials(viewer.name);

  const t = useFormatMessage();
  const signInLabel = t(intlMessages.signIn);
  const accountLabel = t(intlMessages.account, { userNameInitials });

  const { enableUserAccounts, autoRedirectSsoUrl } = authenticationConfig;

  if (!enableUserAccounts) {
    return null;
  }

  const profilePath = pathFor("profileEdition");

  const onSignInClick = () => {
    if (autoRedirectSsoUrl) {
      window.location.href = autoRedirectSsoUrl;
      return;
    }

    props.displayAuthenticationManager(() => window.location.reload());
  };

  const showLabel = !props.hideLabel && isDesktop;

  const containerClassName = classNames([
    "main-menu-authenticated-user",
    { "padding-left-xs": !desktopLegacyDisplay }
  ]);

  const desktopButtonClassName = classNames([
    "nav-link",
    "d-flex",
    "padding-x-xs",
    "align-items-center",
    "h-100",
    "btn-primary"
  ]);

  const nonDesktopButtonClassName = classNames(["btn-unstyled"]);

  const signInButtonClassName = withinComplexMenu
    ? "btn btn-primary btn-sm"
    : "btn-unstyled nav-link nav-link-top-level text-primary-inverse btn-md btn-primary btn-centered";

  const signInButtonInnerClassName = withinComplexMenu ? null : "text-btn-lg";

  const signInButtonIconClassName = classNames("icon-connexion", {
    "margin-right-xs": showLabel,
    "margin-right-none": !showLabel
  });

  const userAvatarClassName = classNames([
    "authenticated-user-avatar",
    { "mr-2": desktopLegacyDisplay }
  ]);

  const userAvatarSize = desktopLegacyDisplay || isDesktop ? 35 : undefined;

  if (viewer.isUser) {
    return (
      <div className={containerClassName}>
        <ButtonLink
          className={
            desktopLegacyDisplay ? desktopButtonClassName : nonDesktopButtonClassName
          }
          href={profilePath}
          aria-label={accountLabel}
          data-user-profile-button
        >
          <UserAvatar
            className={userAvatarClassName}
            user={viewer}
            inverse={desktopLegacyDisplay}
            size={userAvatarSize}
          />
        </ButtonLink>
      </div>
    );
  } else {
    return (
      <div className="main-menu-unauthenticated-user">
        <Button
          className={signInButtonClassName}
          type="button"
          onClick={onSignInClick}
          label={showLabel && signInLabel}
          iconClassName={signInButtonIconClassName}
          innerClassName={signInButtonInnerClassName}
          data-sign-in-button
        />
      </div>
    );
  }
};

const HeaderAuthenticatedUser_authenticationConfig = graphql__6cbaffe096bcf7897e2b;

const HeaderAuthenticatedUser_viewer = graphql__eacef6b6aa6b4a2dc72a;

export default withAuthenticationManager(HeaderAuthenticatedUser);

const intlMessages = defineMessages({
  signIn: {
    id: "navigation.user.signIn",
    defaultMessage: "Se connecter"
  },
  account: {
    id: "navigation.user.account",
    defaultMessage: "{userNameInitials} - Mon profil"
  }
});
